<template>
  <modal :closeable="true" @abort="closeModal">
    <template>
      <h3>{{ $t('titles.stop_auto_renew') }}</h3>
    </template>
    <template>
      <div class="text">
        <p>{{$t('messages.stop_auto_renew_title')}}</p>
        <div v-html="message" class=""/>
        <!--        {{ currentUser.membership.cancellableAt }} -->
      </div>
      <div class="button-wrapper">
        <primary-button @click="cancel" :disabled="formSubmitted" cta>{{ $t('buttons.stop_auto_renew') }}</primary-button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modal/ModalRegular.vue'
// import InputGroup       from '@/components/input/InputGroup.vue'
// import SecondaryButton    from '@/components/buttons/SecondaryButton.vue'
import {SET_IS_ERROR} from '@/store/mutationTypes'
import PrimaryButton from "@/components/buttons/PrimaryButton";
import markdown from "markdown";

export default {
  data() {
    return {
      formSubmitted: false,
    }
  },
  computed: {
    message() {
      return markdown.markdown.toHTML(this.$t('messages.stop_auto_renew_markdown'));
    },
    branch() {
      return process.env.FG_APP_BRANCH
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
  },
  methods: {
    closeModal() {
      this.$router.push({path: '/'})
    },

    cancel() {
      this.formSubmitted = true
      const params = {
        id: this.$store.getters.currentUser.membership.id,
      };

      this.$store.dispatch('cancelMembership', params)
          // .then((response) => {
          .then(() => {
            this.formSubmitted = false
            this.$router.replace({path: '/'})
          }, () => {
            this.formSubmitted = false
            this.$store.commit(SET_IS_ERROR, false)
          })
    },

  },
  mounted() {
    // remove any former errors
    this.$store.commit(SET_IS_ERROR, false)
  },
  components: {
    PrimaryButton,
    Modal
  }
}
</script>

<style lang="scss" scoped>
.text {
  margin: 15px 0 30px 0;

  p {
    //font-family: $secondary-font-family;
    font-size: 1rem;
  }
}

.label {
  //font-size: 0.9375rem;
  color: $body-color;
  //font-weight: bold;
  //font-family: $secondary-font-family;
  margin-right: 20px;
}

.form-row.stripe-elements-container {
  margin-top: 30px - 8px;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 750px) {
    justify-content: flex-end;
  }
}

.card-input {
  @media screen and (max-width: 750px) {
    flex: 1 1 100%;
  }
}


.submit-container {
  display: flex;
  flex-direction: column;

  .payment-error {
    flex: 1;
    margin-top: 30px - 8px;
    color: $error;
    text-align: left;
    //font-family: $secondary-font-family;

    //h4 {
    //  font-size: 1rem;
    //  font-weight: bold;
    //}

    h6 {
      font-size: 1rem;
      font-weight: normal;
    }

    @media screen and (max-width: 750px) {
      text-align: center;
      flex-direction: column;
    }
  }

  .payment-submit {
    text-align: right;
    width: 100%;

    .button-wrapper {
      justify-content: flex-end;
      margin: 0 auto;
      @media screen and (max-width: 750px) {
        justify-content: center;
      }
    }
  }

  @media screen and (max-width: 750px) {
    text-align: center;
    flex-direction: column;
  }
}

.sq-input {
  // height:38px
}

.stripe-elements-wrapper {
  border-bottom: 2px solid $border-color;
  padding: 10px 0 15px 0;
}

</style>

